import { Button, Modal, Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineContrast } from "react-icons/md";
import { getThemeMode, setThemeMode, THEME_MODES } from "../../../style/theme-mode";

/**
 * Koyu tema duyurusu — tarayıcı başına BİR KEZ, 30 Eylül 2026 gün sonuna kadar.
 *
 * Bayrak localStorage'da, tema seçimiyle aynı yerde (bkz. theme-mode.js): migration/sunucu durumu yok;
 * bedeli, kullanıcının başka bir bilgisayarda duyuruyu bir kez daha görmesi.
 * - Bayrak modal AÇILIRKEN yazılır: kullanıcı kapatmadan sayfayı yenilese de tekrar çıkmaz.
 * - Depolama okunamıyorsa (gizli pencere, engelli site verisi) hiç gösterilmez — yoksa her açılışta çıkardı.
 * - Zaten koyu temadaysa düğmeyi bulmuş demektir: gösterilmez, yalnız bayrak yazılır.
 */
const STORAGE_KEY = 'ris-dark-theme-announcement-seen';

// Yerel saatle 1 Ekim 2026 00:00 (ay 0 tabanlı: 9 = Ekim) → 30 Eylül dahil gösterilir.
const SHOW_UNTIL = new Date(2026, 9, 1);

const shouldShow = () => {
    if (new Date() >= SHOW_UNTIL)
        return false;

    try {
        if (localStorage.getItem(STORAGE_KEY))
            return false;

        if (getThemeMode() === THEME_MODES.DARK) {
            localStorage.setItem(STORAGE_KEY, '1');
            return false;
        }

        return true;
    } catch {
        return false;
    }
};

export default function DarkThemeAnnouncement() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(shouldShow);

    useEffect(() => {
        if (!open)
            return;

        try {
            localStorage.setItem(STORAGE_KEY, '1');
        } catch {
            // shouldShow okuyabildiyse yazma da çalışır; çalışmazsa en kötü ihtimalle bir kez daha görünür.
        }
    }, [open]);

    const close = () => setOpen(false);

    const switchToDark = () => {
        setThemeMode(THEME_MODES.DARK);
        close();
    };

    return (
        <Modal
            open={open}
            centered
            width={480}
            title={t('New: Dark theme')}
            onCancel={close}
            footer={[
                <Button key="light" onClick={close}>
                    {t('Stay on light theme')}
                </Button>,
                <Button key="dark" type="primary" icon={<MdOutlineContrast />} onClick={switchToDark}>
                    {t('Switch to dark theme')}
                </Button>,
            ]}
        >
            <Typography.Paragraph>
                {t('DARK_THEME_ANNOUNCEMENT_BODY')}
            </Typography.Paragraph>
            {/* Header'daki düğmenin simgesi: kullanıcı geri dönüş yerini simgeden tanısın. */}
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', padding: 12, borderRadius: 8, background: 'var(--surface-2)' }}>
                <span style={{ display: 'inline-flex', paddingTop: 2, fontSize: 18, color: 'var(--text-2)' }}>
                    <MdOutlineContrast />
                </span>
                <Typography.Text>
                    {t('DARK_THEME_ANNOUNCEMENT_HOW_TO_RETURN')}
                </Typography.Text>
            </div>
        </Modal>
    );
}
